import React from "react";
import { LOGO_URL } from "../../lib/brand";

export default function Logo({ compact = false, className = "" }) {
  return (
    <div data-testid="brand-logo" className={`flex items-center ${className}`} style={{ width: compact ? 140 : 200, height: compact ? 42 : 60 }}>
      <img src={LOGO_URL} alt="Modern Healthcare Plans of America" className="w-full h-full object-contain" />
    </div>
  );
}
